import React from "react";
import RankBadge from "./RankBadge";

type OverallRank = {
  id: string
  level: number;
  title: string;
  name: string;
  slug: string;
};

type LearnerOverallRank = {
  overall_rank_id: string
};

type RankBadgeContainerProps = {
  overall_ranks: OverallRank[];
  learner_overall_rank: LearnerOverallRank;
};

export default function RankBadgesContainer({ overall_ranks, learner_overall_rank }: RankBadgeContainerProps) {
  let learnerRank = null

  if (learner_overall_rank) {
    learnerRank = overall_ranks.find(
      (rank) => rank.id === learner_overall_rank.overall_rank_id
    );
  }

  return (
    <div className="rank-badge-container">
      {overall_ranks.map((rank) => (
        <RankBadge
          key={rank.level}
          level={rank.level}
          slug={rank.slug}
          unlocked={learnerRank && learnerRank.level >= rank.level}
        />
      ))}
    </div>
  );
}
